import { Directive } from '@angular/core';
import { LayoutDirective } from '@angular/flex-layout';

const selector = `[fxLayout.handset.landscape]`;
const inputs = ['fxLayout.handset.landscape'];

@Directive({
  selector, 
  inputs
})
export class CustomFxLayoutHandsetLandscapeDirective extends LayoutDirective {
  protected inputs = inputs;
}
